<template>
  <div class="container">
    <div class="headFilters">
      <el-form inline :model="queryForm">
        <el-form-item :label="$t('AgentID')">
          <el-input
            v-model="queryForm.UserId"
            :placeholder="$t('EnterAgentID')"
            style="width: 150px"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addRow"
            >{{ $t('AddNewAgent') }}</el-button
          >
          <el-button type="primary" @click="toBatchModifyLogo"
            >{{$t('LogoBatchEditLogo')}}/Icon</el-button
          >
          <el-button type="primary" icon="el-icon-refresh" @click="getListData"
            >{{$t('Search')}}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div style="margin-top: 20px">
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ padding: '0' }"
      >
        <el-table-column prop="Id" align="center" label="ID"></el-table-column>
        <el-table-column align="center" :label="$t('Channel')" width="100">
          <template slot-scope="scope">
            <span>{{ channelmap[scope.row.ChannelId] }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="150px"
          prop="CreateTime"
          align="center"
          :label="$t('CreationTime')"
        ></el-table-column>
        <el-table-column align="center" :label="$t('AgentID')">
          <template slot-scope="scope">
            <span
              style="color: #409eff; cursor: pointer"
              @click="editRow(scope.row)"
              >{{ scope.row.UserId }}</span
            >
          </template>
        </el-table-column>
        <el-table-column
          prop="AgentName"
          width="150px"
          show-overflow-tooltip
          align="center"
          :label="$t('AgentName')"
        ></el-table-column>
        <el-table-column
          prop="ShowName"
          width="150px"
          show-overflow-tooltip
          align="center"
          :label="$t('DisplayName')"
        ></el-table-column>
        <el-table-column
          prop="Host"
          width="150px"
          show-overflow-tooltip
          align="center"
          :label="$t('AgentDomain')"
        ></el-table-column>
        <el-table-column prop="CommissionRate" align="center" :label="$t('CommissionRebateRatio')">
        </el-table-column>
        <el-table-column width="150px" align="center" :label="$t('CommissionPlan')">
          <template slot-scope="scope">
            <span
              style="color: #409eff; cursor: pointer"
              @click="changePlan(scope.row)"
              >{{ scope.row.planName }}</span
            >
          </template>
        </el-table-column>
        <el-table-column width="100px" align="center" :label="$t('HistoryOfModifiedPlans')">
          <template slot-scope="scope">
            <span
              style="color: #409eff; cursor: pointer"
              @click="toHistoryPlan(scope.row)"
              >{{$t('View')}}</span
            >
          </template>
        </el-table-column>
        <!-- <el-table-column prop="CommissionRate" width="100px" align="center" :label="$t('CommissionPlan')">
          <template slot-scope="scope">
            <el-button @click="changePlan(scope.row)" type="text">98佣金方案</el-button>
          </template>
        </el-table-column> -->
        <el-table-column prop="Host" width="150px" :label="$t('designated')">
          <template slot-scope="scope">
            <span v-if="scope.row.IsSuper == 1" style="margin-right: 20px"
              >{{$t('Yes')}}</span
            >
            <span v-else style="margin-right: 20px">否</span>
            <!-- <el-button @click="manageRow(scope.row)" type="text">管理</el-button> -->
          </template>
        </el-table-column>
        <el-table-column
          prop="Memo"
          show-overflow-tooltip
          width="150px"
          align="center"
           :label="$t('Remarks')"
        >
        </el-table-column>
        <el-table-column prop="APITYk" align="center"  :label="$t('Actions')">
          <!-- <el-table-column width="100px" align="center" label="独立投注地址">
            <template slot-scope="scope">
              <el-switch v-model="tableData[scope.$index].IsSelfAddress" :width="35" :inactive-text="tableData[scope.$index].IsSelfAddress ? $t('Open') : $t('TurnOff')" @change="changeRow($event, scope.row, scope.$index, 'IsSelfAddress')" style="margin-right: 5px;">
              </el-switch> -->
          <!-- <el-button @click="jianPeiSettings(scope.row)" type="text" icon="el-icon-edit">降赔</el-button>
              <el-button @click="universalSettings(scope.row)" type="text" icon="el-icon-edit">通用设置</el-button>
              <el-button @click="niuNiuSettings(scope.row)" type="text" icon="el-icon-edit">牛牛设置</el-button>
              <el-button @click="zhuangXianSettings(scope.row)" type="text" icon="el-icon-edit">庄闲设置</el-button> -->
          <!-- </template> -->
          <!-- </el-table-column> -->
          <el-table-column width="150px" align="center" :label="$t('IndependentCustomerService')">
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfCustomService"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfCustomService ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow(
                    $event,
                    scope.row,
                    scope.$index,
                    'IsSelfCustomService'
                  )
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editCustomerService(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="100px" align="center" :label="$t('FlashExchangeFeature')">
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsDuiHuan"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsDuiHuan ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow($event, scope.row, scope.$index, 'IsDuiHuan')
                "
                style="margin-right: 5px"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column width="150px" align="center" :label="$t('IndependentAgentBackend')">
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfBackOffice"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfBackOffice ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow($event, scope.row, scope.$index, 'IsSelfBackOffice')
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editAgentBackend(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="150px" align="center" :label="$t('IndependentBettingRobot')">
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfTgBot"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfTgBot ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow($event, scope.row, scope.$index, 'IsSelfTgBot')
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editBettingRobots(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column width="150px" align="center" :label="$t('IndependentActivity')">
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfActive"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfActive ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow($event, scope.row, scope.$index, 'IsSelfActive')
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editIndependentActivities(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column>
          <!-- <el-table-column
            width="150px"
            align="center"
            label="旧版独立游戏大项排序"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfMajorGameOrder"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfMajorGameOrder ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow(
                    $event,
                    scope.row,
                    scope.$index,
                    'IsSelfMajorGameOrder'
                  )
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editBigSort(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            width="150px"
            align="center"
            label="新版独立游戏大项排序"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfMajorGameOrderNew"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfMajorGameOrderNew
                    ? $t('Open')
                    : $t('TurnOff')
                "
                @change="
                  changeRow(
                    $event,
                    scope.row,
                    scope.$index,
                    'IsSelfMajorGameOrderNew'
                  )
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editBigSortNew(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            width="150px"
            align="center"
            label="独立游戏小项排序"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="tableData[scope.$index].IsSelfMinorGameOrder"
                :width="35"
                :inactive-text="
                  tableData[scope.$index].IsSelfMinorGameOrder ? $t('Open') : $t('TurnOff')
                "
                @change="
                  changeRow(
                    $event,
                    scope.row,
                    scope.$index,
                    'IsSelfMinorGameOrder'
                  )
                "
                style="margin-right: 5px"
              >
              </el-switch>
              <el-button
                @click="editSmallSort(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Edit')}}</el-button
              >
            </template>
          </el-table-column> -->
          <el-table-column width="150px" align="center" :label="$t('Delete')">
            <template slot-scope="scope">
              <el-button
                style="color: red"
                @click="deletRow(scope.row)"
                type="text"
                icon="el-icon-edit"
                >{{$t('Delete')}}</el-button
              >
            </template>
          </el-table-column>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        :total="total"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :page-sizes="pagesizes"
        :current-page="current_row"
      >
      </el-pagination>
    </div>
    <!-- 新增/编辑代理 -->
    <addAndEdit
      v-if="addAndEditData.show"
      @addAndEdit="addAndEdit"
      :addAndEditData="addAndEditData"
    ></addAndEdit>
    <!-- 编辑独立客服 -->
    <!-- <customerService
      @submitCustomerServiceData="submitCustomerServiceData"
      v-if="customerServiceData.show"
      :customerServiceData="customerServiceData"
    ></customerService> -->
    <InAgentEditCustomer
      @reqModifyUrl="submitCustomerServiceData"
      v-if="customerServiceData.show"
      :dialogData="customerServiceData"
    ></InAgentEditCustomer>
    <!-- 独立代理 -->
    <agentBackend
      @submitAgentBackendData="submitAgentBackendData"
      v-if="agentBackendData.show"
      :agentBackendData="agentBackendData"
    ></agentBackend>
    <bettingRobots
      @submitBettingRobotsData="submitBettingRobotsData"
      v-if="bettingRobotsData.show"
      :bettingRobotsData="bettingRobotsData"
    ></bettingRobots>
    <!-- 独立代理活动 -->
    <independentActivities
      @submitIndependentActivitiesData="submitIndependentActivitiesData"
      v-if="independentActivitiesData.show"
      :independentActivitiesData="independentActivitiesData"
    >
    </independentActivities>
    <!-- 游戏大类排序 -->
    <bigSort
      @confirmBigSort="confirmBigSort"
      v-if="bigSortData.show"
      :bigSortData="bigSortData"
    ></bigSort>
    <!-- 游戏小类排序 -->
    <smallSort
      @confirmSmallSortData="confirmSmallSortData"
      v-if="smallSortData.show"
      :smallSortData="smallSortData"
    >
    </smallSort>
    <!-- 特定代理线管理 -->
    <manage v-if="manageData.show" :manageData="manageData"></manage>
    <!-- 方案变更 -->
    <changePlan
      v-if="changePlanData.show"
      :changePlanData="changePlanData"
      @confirmChangePlanData="confirmChangePlanData"
    >
    </changePlan>
    <!-- 降赔 -->
    <jianPeiSetting
      v-if="jianPeiSettingData.show"
      :jianPeiSettingData="jianPeiSettingData"
    ></jianPeiSetting>
    <!-- 通用游戏设置 -->
    <universalSetting
      v-if="universalSettingData.show"
      :universalSettingData="universalSettingData"
    ></universalSetting>
    <!-- 牛牛游戏设置 -->
    <niuNiuSetting
      v-if="niuNiuSettingData.show"
      :niuNiuSettingData="niuNiuSettingData"
    ></niuNiuSetting>
    <!-- 庄闲游戏设置 -->
    <zhuangXianSetting
      v-if="zhuangXianSettingData.show"
      :zhuangXianSettingData="zhuangXianSettingData"
    >
    </zhuangXianSetting>
    <!-- 查看历史方案 -->
    <historyPlan
      v-if="historyPlanData.show"
      :historyPlanData="historyPlanData"
    />
    <!-- 新版游戏大类排序 -->
    <bigSortNew
      @confirmBigSortNew="confirmBigSortNew"
      v-if="bigSortNewData.show"
      :bigSortNewData="bigSortNewData"
    />
    <!-- 批量修改logo -->
    <BatchModifyLogo
      v-if="logoData.show"
      :logoData="logoData"
      @submitLogoData="submitLogoData"
    />
  </div>
</template>

<script>
import { app } from "@/api/app.js";
import base from "@/api/base.js";
import addAndEdit from "./dialog/addAndEdit.vue";
// import bettingAddress from './dialog/bettingAddress.vue'
import customerService from "./dialog/customerService.vue";
import agentBackend from "./dialog/agentBackend.vue";
import bettingRobots from "./dialog/bettingRobots.vue";
import independentActivities from "./dialog/independentActivities.vue";
import bigSort from "./dialog/bigSort.vue";
import smallSort from "./dialog/smallSort.vue";
import manage from "./dialog/manage.vue";
import changePlan from "./dialog/changePlan.vue";
import jianPeiSetting from "./dialog/jianPeiSetting.vue";
import universalSetting from "./dialog/universalSetting.vue";
import niuNiuSetting from "./dialog/niuNiuSetting.vue";
import zhuangXianSetting from "./dialog/zhuangXianSetting.vue";
import historyPlan from "./dialog/historyPlan.vue";
import bigSortNew from "./dialog/bigSortNew.vue";
import BatchModifyLogo from "./dialog/BatchModifyLogo.vue";
import InAgentEditCustomer from "./independentAgent/InAgentEditCustomer.vue";
export default {
  name: "iagent_list",
  extends: base,
  components: {
    addAndEdit,
    // bettingAddress,
    customerService,
    agentBackend,
    bettingRobots,
    independentActivities,
    bigSort,
    smallSort,
    manage,
    changePlan,
    jianPeiSetting,
    universalSetting,
    niuNiuSetting,
    zhuangXianSetting,
    historyPlan,
    bigSortNew,
    BatchModifyLogo,
    InAgentEditCustomer,
  },
  data() {
    return {
      tableData: [],
      addAndEditData: {
        show: false,
        title: this.$t('AddNewAgent'),
        baseurl: "",
        list: [],
        rowData: {},
      },
      bettingAddressData: {
        show: false,
        title: this.$t('EditIndependentBettingAddress'),
        rowData: {},
      },
      customerServiceData: {
        show: false,
        title: this.$t('EditIndependentCustomerService'),
        row: {},
      },
      agentBackendData: {
        show: false,
        title: this.$t('EditIndependentAgentBackend'),
        rowData: {},
      },
      bettingRobotsData: {
        show: false,
        title: this.$t('EditIndependentBettingBot'),
        rowData: {},
      },
      independentActivitiesData: {
        show: false,
        title: this.$t('EditIndependentActivity'),
        rowData: {},
      },
      bigSortData: {
        show: false,
        title: this.$t('OldVersionGameCategorySortDrag'),
        rowData: {},
      },
      bigSortNewData: {
        show: false,
        title: this.$t('NewVersionGameCategorySortDrag'),
        rowData: {},
      },
      smallSortData: {
        show: false,
        title: this.$t('GameSubCategorySortDrag'),
        rowData: {},
      },
      manageData: {
        show: false,
        title: this.$t('SpecificAgentLineManagement'),
        rowData: {},
      },
      changePlanData: {
        show: false,
        title: this.$t('ChangeAgentPlan'),
        lis: [],
        rowData: {},
      },
      jianPeiSettingData: {
        show: false,
        title: this.$t('ApplyDowngradeScheme'),
        rowData: {},
      },
      universalSettingData: {
        show: false,
        title: this.$t('GeneralGameSettings'),
        rowData: {},
      },
      niuNiuSettingData: {
        show: false,
        title: this.$t('BullGameSettings'),
        rowData: {},
      },
      zhuangXianSettingData: {
        show: false,
        title: this.$t('BaccaratGameSettings'),
        rowData: {},
      },
      bigSortList: [],
      queryForm: {
        UserId: "",
      },
      planList: [],
      historyPlanData: {
        show: false,
        title: this.$t('HistoricalPlans'),
        rowData: {},
      },
      logoData: {
        show: false,
      },
    };
  },
  async created() {
    this.app = app;
    this.getChannel(this.filters.SellerId);
    this.getListData();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/iagent_config") {
        vm.getListData();
      }
    });
  },
  methods: {
    // 批量修改logo
    toBatchModifyLogo() {
      this.logoData.show = true;
    },
    //批量修改logo提交
    submitLogoData(val = {}) {
      app.post(
        "/agent/agent_independence_update_logo_icon",
        { ...val },
        (result) => {
          if (result.code == 200) {
            this.logoData.show = false;
            this.getListData();
            this.$message({
              message: this.$t('ModificationSuccessful'),
              type: "success",
            });
          }
        }
      );
    },
    // 历史方案
    toHistoryPlan(row) {
      this.historyPlanData.rowData = row;
      this.historyPlanData.show = true;
    },
    // 获取佣金方案列表
    getPlanList(res) {
      const data = {
        SellerId: this.filters.SellerId,
        Name: "",
        Page: 1,
        PageSize: 1000,
      };
      app.post("/agent/get_config_t1", data, (result) => {
        if (result.code == 200) {
          this.tableData = res.data.data;
          this.total = res.data.total;
          this.addAndEditData.baseurl = res.data.url;
          this.planList = result.data.data;
          this.tableData.forEach((item) => {
            item.planName = "--";
            item.IsSelfAddress = item.IsSelfAddress == 1 ? true : false;
            item.IsSelfHost = item.IsSelfHost == 1 ? true : false;
            item.IsSelfCustomService =
              item.IsSelfCustomService == 1 ? true : false;
            item.IsDuiHuan = item.IsDuiHuan == 1 ? true : false;
            item.IsSelfBackOffice = item.IsSelfBackOffice == 1 ? true : false;
            item.IsSelfActive = item.IsSelfActive == 1 ? true : false;
            item.IsSelfMajorGameOrder =
              item.IsSelfMajorGameOrder == 1 ? true : false;
            item.IsSelfMinorGameOrder =
              item.IsSelfMinorGameOrder == 1 ? true : false;
            item.IsSelfTgBot = item.IsSelfTgBot == 1 ? true : false;
            item.IsSelfMajorGameOrderNew =
              item.IsSelfMajorGameOrderNew == 1 ? true : false;
            this.planList.forEach((ele) => {
              if (item.AgentUseId == ele.Id) {
                item.planName = ele.Name;
              }
            });
          });
        }
      });
    },
    jianPeiSettings(row) {
      this.jianPeiSettingData.show = true;
      this.jianPeiSettingData.rowData = row;
    },
    universalSettings(row) {
      this.universalSettingData.show = true;
      this.universalSettingData.rowData = row;
    },
    niuNiuSettings(row) {
      this.niuNiuSettingData.show = true;
      this.niuNiuSettingData.rowData = row;
    },
    zhuangXianSettings(row) {
      this.zhuangXianSettingData.show = true;
      this.zhuangXianSettingData.rowData = row;
    },
    changePlan(row) {
      this.changePlanData.show = true;
      this.changePlanData.list = this.planList;
      this.changePlanData.rowData = row;
    },
    manageRow(row) {
      this.manageData.show = true;
      this.manageData.rowData = row;
    },
    deletRow(row) {
      app.getGoogleCode((GoogleCode) => {
        let data = {
          SellerId: this.filters.SellerId,
          UserId: Number(row.UserId),
          GoogleCode,
        };
        app.post("/agent/agent_independence_delete", data, (res) => {
          if (res.code == 200) {
            this.getListData();
            this.$message({
              message: "删除成功",
              type: "success",
            });
          }
        });
      });
    },
    getListData() {
      const data = {
        SellerId: this.filters.SellerId,
        UserId: Number(this.queryForm.UserId),
        Page: this.page,
        PageSize: this.pagesize,
      };
      app.post(
        "/agent/agent_independence_list",
        data,
        (res) => {
          if (res.code == 200) {
            this.getPlanList(res);
          }
        },
        true
      );
    },
    addRow() {
      this.addAndEditData.show = true;
      this.addAndEditData.title = this.$t('AddNewAgent');
      this.addAndEditData.list = this.planList;
    },
    editRow(row) {
      this.addAndEditData.show = true;
      this.addAndEditData.list = this.planList;
      this.addAndEditData.rowData = row;
      this.addAndEditData.title = this.$t('Edit');
    },
    editBettingAddress(row) {
      this.bettingAddressData.show = true;
      this.bettingAddressData.rowData = row;
    },
    editCustomerService(pRow) {
      this.customerServiceData.show = true;
      this.customerServiceData.row = pRow;
    },
    editAgentBackend(row) {
      this.agentBackendData.show = true;
      this.agentBackendData.rowData = row;
    },
    editBettingRobots(row) {
      this.bettingRobotsData.show = true;
      this.bettingRobotsData.rowData = row;
    },
    editIndependentActivities(row) {
      this.independentActivitiesData.show = true;
      this.independentActivitiesData.rowData = row;
    },
    editBigSort(row) {
      this.bigSortData.show = true;
      this.bigSortData.rowData = row;
    },
    editBigSortNew(row) {
      this.bigSortNewData.show = true;
      this.bigSortNewData.rowData = row;
    },
    editSmallSort(row) {
      this.smallSortData.show = true;
      this.smallSortData.rowData = row;
    },
    // 新增
    addRequest(val) {
      app.getGoogleCode((GoogleCode) => {
        let data = {
          SellerId: this.filters.SellerId,
          UserId: Number(val.UserId),
          AgentHost: val.Host,
          CommissionRate: Number(val.CommissionRate),
          Memo: val.Memo,
          AgentName: val.AgentName,
          ShowName: val.ShowName,
          IsSuper: Number(val.IsSuper || 2),
          Icon: val.Icon,
          Logo: val.Logo,
          Logo2: val.Logo2,
          AgentUseId: Number(val.AgentUseId),
          PromotionHost: val.PromotionHost,
          GoogleCode,
          PromotionHost: val.PromotionHost,
          AddType: val.AddType,
          Password: val.Password,
        };
        app.post("/agent/agent_independence_add", data, (res) => {
          if (res.code == 200) {
            this.getListData();
            this.$message({
              message: "新增成功",
              type: "success",
            });
          }
        });
      });
    },
    // 编辑
    editRequest(val = {}, obj = {}) {
      app.getGoogleCode(
        (GoogleCode) => {
          let data = {
            SellerId: this.filters.SellerId,
            UserId: Number(val.UserId),
            CommissionRate: Number(val.CommissionRate),
            Memo: val.Memo,
            AgentUseId: Number(val.AgentUseId),
            Host: val.Host,
            AgentName: val.AgentName,
            ShowName: val.ShowName,
            IsSuper: Number(val.IsSuper || 2),
            Icon: val.Icon,
            Logo: val.Logo,
            Logo2: val.Logo2,
            TgInfo: val.TgInfo,
            ActiveInfo: val.ActiveInfo,
            BackOffaceInfo: val.BackOffaceInfo,
            CustomeService: val.CustomeService,
            MajorGameOrder: val.MajorGameOrder,
            MajorGameOrderNew: val.MajorGameOrderNew,
            MinorGameOrder: val.MinorGameOrder,
            IsSelfHost: val.IsSelfHost ? 1 : 2,
            IsDuiHuan: val.IsDuiHuan ? 1 : 2,
            IsSelfBackOffice: val.IsSelfBackOffice ? 1 : 2,
            IsSelfTgBot: val.IsSelfTgBot ? 1 : 2,
            IsSelfActive: val.IsSelfActive ? 1 : 2,
            IsSelfMajorGameOrder: val.IsSelfMajorGameOrder ? 1 : 2,
            IsSelfMinorGameOrder: val.IsSelfMinorGameOrder ? 1 : 2,
            IsSelfAddress: val.IsSelfAddress ? 1 : 2,
            IsSelfCustomService: val.IsSelfCustomService ? 1 : 2,
            IsSelfMajorGameOrderNew: val.IsSelfMajorGameOrderNew ? 1 : 2,
            GoogleCode,
            IsBatch: val.IsBatch,
            ChannelId: val.ChannelId,
            PromotionHost: val.PromotionHost,
          };
          app.post("/agent/agent_independence_modify", data, (res) => {
            if (res.code == 200) {
              this.getListData();
              this.$message({
                message: res.msg,
                type: "success",
              });
            }
          });
        },
        () => {
          if (obj.type == "Cancel") {
            this.tableData[obj.index][obj.key] =
              !this.tableData[obj.index][obj.key];
          }
        }
      );
    },
    // 新增/编辑
    addAndEdit(val) {
      if (this.addAndEditData.title == this.$t('Edit')) {
        this.editRequest(val);
      } else {
        this.addRequest(val);
      }
      this.addAndEditData.show = false;
    },
    // 开关编辑
    changeRow(val, row, index, key) {
      this.editRequest(row, { index, key, type: "Cancel" });
    },
    // 编辑独立客服
    submitCustomerServiceData(row) {
      this.editRequest(row);
      this.customerServiceData.show = false;
    },
    // 代理后台
    submitAgentBackendData(row) {
      this.editRequest(row);
      this.agentBackendData.show = false;
    },
    // 投注机器人
    submitBettingRobotsData(row) {
      this.editRequest(row);
      this.bettingRobotsData.show = false;
    },
    // 独立活动
    submitIndependentActivitiesData(row) {
      this.editRequest(row);
      this.independentActivitiesData.show = false;
    },
    // 游戏大类排序
    confirmBigSort(row) {
      this.editRequest(row);
      this.bigSortData.show = false;
    },
    confirmBigSortNew(row) {
      this.editRequest(row);
      this.bigSortNewData.show = false;
    },
    // 游戏小类
    confirmSmallSortData(row) {
      this.editRequest(row);
      this.smallSortData.show = false;
    },
    // 方案变更
    confirmChangePlanData(row) {
      this.editRequest(row);
      this.changePlanData.show = false;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getListData();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getListData();
    },
  },
};
</script>

<style scoped>
::v-deep .el-switch__label.is-active {
  color: red;
}

::v-deep .el-switch__label {
  color: #409eff;
}
</style>
